import {connect} from 'react-redux';
import {TimelineState} from '../../../Timeline/Redux/TimelineReducer';
import {
    toggleSelectedMarkerAction,
    toggleSelectedRowAction,
} from '../../../Timeline/Redux/TimelineActions';
import SubtitleTrackContainer from './SubtitleTrackContainer';
import {
    enableSubtitleAction,
    disableSubtitleAction,
} from '../Redux/SubtitleTracksActions';

interface StateProps {
    selectedMarkerId: string;
    selectedRowId: string;
}

interface TimelineStore {
    selectedMarker: TimelineState;
}

export type MarkerState = {
    timeline: TimelineStore;
}

export const mapState = (state: MarkerState): StateProps => {
    const {timeline} = state;
    const {selectedMarker} = timeline;
    const {
        selectedMarkerId,
        selectedRowId,
    } = selectedMarker;
    
    return {
        selectedMarkerId,
        selectedRowId,
    };
};

export const mapDispatch = {
    toggleSelectedMarker: toggleSelectedMarkerAction,
    toggleSelectedRow: toggleSelectedRowAction,
    enableSubtitle: enableSubtitleAction,
    disableSubtitle: disableSubtitleAction,
};

export default connect(mapState, mapDispatch)(SubtitleTrackContainer);
